// extracted by mini-css-extract-plugin
export var contentBody = "_ao-9";
export var headerImage = "_ao-2";
export var imageButton = "_ao-7";
export var imageButtonIcon = "_ao-8";
export var imageHeader = "_ao-4";
export var imageHeaderText = "_ao-5";
export var imageOverlay = "_ao-3";
export var imageTitle = "_ao-6";
export var imageWrapper = "_ao-1";
export var taskList = "_ao-a";
export var widget = "_ao-0";